import { FormElement, IFormElementProperties } from '@vfde-brix/ws10/form-element';

export const markAsRequired = (inputs: FormElement[]) => {
    const markerString = '<span class="text-primary-100">*</span>';

    for (const input of inputs) {
        const props: IFormElementProperties = input.getProperties();

        const updatedProps = {
            ...props,
            stdLabel: `${props.stdLabel ?? ''}${markerString}`,
        };

        input.update(updatedProps);
    }
};
